import React, { useEffect, useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import inputStyle from './inputText.module.scss';
import { HorizontalFlex } from "../flex/HorizontalFlex";

const ControlledInput = ({
  value,
  onValueChange,
  formatter,
  parser,
  min,
  max,
  unit,
}) => {
  // unit은 별도로 받아오고, 숫자 부분만 추출해서 input 초기값으로 설정
  const extractNumeric = (str) => {
    const match = str.match(/[\d.,]+/);
    return match ? match[0] : '';
  };

  const [text, setText] = useState(extractNumeric(formatter(value)));
  // const [text, setText] = useState(formatter(value));

  useEffect(() => {
    setText(extractNumeric(formatter(value)));
  }, [value, formatter]);

  const clamp = (val) => {
    if (isNaN(val)) return min;
    if (val < min) return min;
    if (val > max) return max;
    return val;
  };

  const commit = () => {
    let parsed = parser(text);
    parsed = clamp(parsed);
    onValueChange(parsed);
    setText(extractNumeric(formatter(parsed)));
  };

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      commit();
    }
  };

  const handleBlur = () => {
    commit();
  };

  return (
    <div className={`${inputStyle.defaultInput} ${inputStyle.useUnit}`}>
      <input
        className= {inputStyle.input}
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
      <span className={inputStyle.spanUnit}> {unit} </span>
    </div>
  );
};

const UnitRangeSlider = ({
  min,
  max,
  step,
  values,
  onChange,
  unitOptions,
  unitIndex,
}) => {

  const activeUnit = unitOptions[unitIndex]; // ✅ 여기를 기준으로 formatter 사용


  return (
    <div style={{ width: '100%', maxWidth: 500, margin: 'auto' }}>

      <HorizontalFlex>
        <ControlledInput
          value={values[0]}
          onValueChange={(v) => onChange([v, values[1]])}
          formatter={activeUnit.format}
          parser={activeUnit.parse}
          min={min}
          max={values[1]} // 최소 입력은 현재 최대값보다 클 수 없음
          unit={activeUnit.label}
        />
        <span style={{ padding: "0 10px" }}>~</span>
        <ControlledInput
          value={values[1]}
          onValueChange={(v) => onChange([values[0], v])}
          formatter={activeUnit.format}
          parser={activeUnit.parse}
          min={values[0]} // 최대 입력은 현재 최소값보다 작을 수 없음
          max={max}
          unit={activeUnit.label}
        />
      </HorizontalFlex>
        
      {/* 슬라이더 */}
      <Range
        values={values}
        step={step}
        min={min}
        max={max}
        onChange={onChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            // className={styles.track}
            style={{
              ...props.style,
              height: '6px',
              background: getTrackBackground({
                values,
                colors: ['#ddd', '#0080ff', '#ddd'],
                min,
                max,
              }),
              borderRadius: 3,
              margin: '20px 0',
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props, index }) => {
          const {key, ...rest } = props;
          return (
          <div
            key ={key}
            {...rest}
            // className= {styles.thumb}
            style={{
              height: "20px",
              width: "20px",
              backgroundColor: "#FFF",
              borderRadius: "50%",
              fill: "#FFF",
              strokeWidth: "1px",
              stroke:"#EAEAEA",
              filter: "drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.15))",
              ...rest.style,
            }}
          />
        )}}
      />

      {/* 하단 라벨 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginTop: 6, color: '#888' }}>
        <span>{activeUnit.format(min)}</span>
        <span>{activeUnit.format(max)}</span>
      </div>
    </div>
  );
};

export default UnitRangeSlider;